import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {Notification, Ribbon, Loading} from 'components/common/uiKit';

import {serverUrl} from 'services/network';
import {CourseApi, UserApi} from 'services/network/api';
import {LocaleAction, RouterAction} from 'services/redux/actions';


class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true
        };

        this.loadData();
        //this.getUserLocale();
    }

    async loadData() {
        //TODO: useLoading

        CourseApi.Get()
            .then(res => {
                if (res && res.status == 200) {
                    let {data} = res;
                    const actives = data.filter(x => x.stateDesc.toLowerCase() == 'active');
                    const others = data.filter(x => x.stateDesc.toLowerCase() != 'active');
                    data = [];
                    data.push(...actives, ...others);
                    this.setState({data});
                }
            }).finally(x => {
            this.setState({loading: false});
        });
    }


    /*    getUserLocale() {
            UserApi.GetLocale()
                .then(res => {
                    if (res && res.status == 200) {
                        const {actions} = this.props;
                        if (typeof (res.data.translation == 'string'))
                            res.data.translation = JSON.parse(res.data.translation);

                        actions.setLocale(res.data);
                    }
                })
        };*/

    handleCourseState(state) {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Home.CourseStatus;

        switch (state.toLowerCase()) {
            case 'inactive':
                return {title: pageTranslates.InActive, type: 'danger'};
            case 'active':
                return {title: pageTranslates.Active, type: 'success'};
            case 'fullcapacity':
                return {title: pageTranslates.FullCapacity};
            case 'canceled':
                return {title: pageTranslates.Canceled, type: 'warning'};
            case 'commingsoon':
                return {title: pageTranslates.CommingSoon, type: 'info'};
        }
    };

    _handleClick = (item) => {
        const {history} = this.props;
        const {id, stateDesc} = item;

        if (stateDesc.toLowerCase() != 'active') {
            Notification('error', 'InActiveLevel');
            return;
        }

        history.push({
            pathname: `course?courseId=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    render() {
        const {data, loading} = this.state;

        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Home;

        return (
            <div className="text-center" style={{padding: '10px 15px'}}>
                {data.map((item, index) => {
                    const {id, image, title, price, time} = item;
                    const imageUrl = `${serverUrl}${image.split('\\').join('/')}`;
                    const imageStyle = {backgroundImage: `url(${imageUrl})`};

                    const ribbonProps = this.handleCourseState(item.stateDesc);

                    return (
                        <a onClick={this._handleClick.bind(this, item)}>
                            <Ribbon {...ribbonProps}>
                                <div className="card rounded-l shadow-l" style={{height: 320, overflow: 'hidden'}}>
                                    <div className="card-bottom">
                                        <h1 className="font-24 font-700 text-center">{title}</h1>
                                        <p className="boxed-text-xl">
                                            {pageTranslates.Price}:
                                            {price.toLocaleString()}
                                            {pageTranslates.Currency}
                                            <br/>
                                            {pageTranslates.ExpireTime}:
                                            {time}
                                            {pageTranslates.Days}
                                        </p>

                                    </div>
                                    <div className="card-overlay bg-gradient-fade"></div>
                                    <div className="card-bg owl-lazy" style={imageStyle}></div>
                                </div>
                            </Ribbon>
                        </a>
                    );
                })}
            </div>
        );
    }
}


const ActionCreators = Object.assign({}, LocaleAction, RouterAction);

const mapDispatchToProps = dispatch => {
    return ({
        actions: bindActionCreators(ActionCreators, dispatch)
    });
};

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));


